import { Box } from '@mui/material';
import accuflow from 'assets/accuflow-logo.png';
import accutech from 'assets/accutech-logo.png';
import cimtec from 'assets/cimtec-logo.png';
import ffp from 'assets/ffp-logo.png';
import tulsa from 'assets/tulsa-logo.png';
import teamTechnical from 'assets/teamtechnical-logo.png';
import triangle from 'assets/triangle-logo.png';
import { Brands } from 'shared/types';
import cbe from 'assets/cbe-logo.png';
import lewis from 'assets/lewis-logo.png';
import indelco from 'assets/indelco-logo.png';
import corrtech from 'assets/corrtech-logo.png';
import nianticseal from 'assets/nianticseal-logo.png';
import qualitystainless from 'assets/qualitystainless-logo.png';
import inscoprocess from 'assets/inscoprocess-logo.png';
import newgen from 'assets/newgen-logo.png';
import prestonphipps from 'assets/prestonphipps-logo.png';
import sepump from 'assets/sepump-logo.png';
import shaltzautomation from 'assets/shaltzautomation-logo.png';
import triphase from 'assets/triphase-logo.png';
import rankin from 'assets/rankin-logo.png';
import smithcameron from 'assets/smithcameron-logo.png';

const getImageSource = (brand: Brands) => {
  switch (brand) {
    case 'accuflow':
      return accuflow;
    case 'cimtec':
      return cimtec;
    case 'ffp':
      return ffp;
    case 'triangle':
      return triangle;
    case 'ffpnorth':
      return ffp;
    case 'texas':
      return ffp;
    case 'tulsa':
      return tulsa;
    case 'teamtechnical':
      return teamTechnical;
    case 'accutech':
      return accutech;
    case 'lewis':
      return lewis;
    case 'cbe':
      return cbe;
    case 'indelco':
      return indelco;
    case 'corrtech':
      return corrtech;
    case 'nianticseal':
      return nianticseal;
    case 'qualitystainless':
      return qualitystainless;
    case 'inscoprocess':
      return inscoprocess;
    case 'newgen':
      return newgen;
    case 'prestonphipps':
      return prestonphipps;
    case 'sepump':
      return sepump;
    case 'shaltzautomation':
      return shaltzautomation;
    case 'triphase':
      return triphase;
    case 'rankin':
      return rankin;
    case 'smithcameron':
      return smithcameron;
    default:
      return undefined;
  }
};

interface BrandLogoProps {
  brand: Brands;
}
export function BrandLogo({ brand }: BrandLogoProps) {
  return (
    <Box
      component='img'
      sx={{ maxHeight: theme => theme.mixins.toolbar.minHeight }}
      src={getImageSource(brand)}
      alt={`${brand} logo`}
    />
  );
}
